import type { IssueType, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { IssueTypeMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const IssueTypeMention = Mention.extend<MentionOptions<Stored<IssueType>>>({
	name: "IssueTypeMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "issue-type-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["issue-type-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(IssueTypeMentionComponent)
	},
}).configure({
	suggestion,
})
